import React from 'react';
import LoginForm from '../../components/auth/LoginForm/LoginForm';

const Login = () => {
  return (
    <div className="min-h-screen flex">
      {/* Left Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <LoginForm />
      </div>

      {/* Right Side - Branding / Illustration */}
      <div className="hidden lg:flex lg:flex-1 bg-gradient-to-br from-primary-400 via-primary-500 to-primary-600 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        
        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full p-12 text-white">
          <div className="max-w-lg">
            {/* Logo */}
            <div className="mb-8">
              <img 
                src="/logo.png" 
                alt="Mara Labs" 
                className="h-20 w-auto"
              />
            </div>

            {/* Title */}
            <h2 className="text-4xl font-bold mb-4 font-display">
              Mara Labs Dashboard
            </h2>
            
            {/* Subtitle */}
            <p className="text-xl text-white/90 mb-8">
              Plataforma de Gestão de Automações
            </p>

            {/* Features */}
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Automação Inteligente</h3>
                  <p className="text-white/80 text-sm">
                    Chatbots com IA que respondem, qualificam e direcionam leads 24/7
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Gestão Centralizada</h3>
                  <p className="text-white/80 text-sm">
                    Acompanhe todas as conversas e automações em um único lugar
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Análises em Tempo Real</h3>
                  <p className="text-white/80 text-sm">
                    Métricas e relatórios detalhados sobre suas automações
                  </p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold mb-1">24/7</div>
                <div className="text-white/80 text-sm">Disponibilidade</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-1">100%</div>
                <div className="text-white/80 text-sm">Automação</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-1">∞</div>
                <div className="text-white/80 text-sm">Escalabilidade</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;